// Shared notifications bridge — NotificationBell + NotificationPanel +
// self-loading NotificationWrapper from @symbo.ls/collab-features/notifications.
// Shared across editor + intranet via sharedLibraries.

import { notifications } from '../collab-features/src/index.js'

export const NotificationBell = notifications.NotificationBell
export const NotificationPanel = notifications.NotificationPanel
export const NotificationWrapper = notifications.NotificationWrapper
